export const config = {
  api_local: process.env.REACT_APP_API_URL, 
  BE_API_URL: process.env.REACT_APP_API_URL,
  site: process.env.REACT_APP_SITE,
  LIST_BANK_NAME: [
    'Ví Điện Tử',
    'ABBANK',
    'ACB BANK',
    'AGRIBANK',
    'ANZBANK',
    'BAC A BANK',
    'BIDVBANK',
    'BVBANK',
    'CAKE',
    'CB BANK',
    'CIMB BANK',
    'CITI',
    'CO OPBANK',
    'DBS',
    'EXIMBANK',
    'GB BANK',
    'HD BANK',
    'HNB',
    'HONGLEONG BANK',
    'HSBC',
    'IBK',
    'KBANK',
    'KIENLONGBANK',
    'KOOKMI',
    'LIENVIET BANK',
    'LIOBANK',
    'MAFC',
    'MBBANK',
    'MODERN BANK OF VIETNAM',
    'MSB BANK',
    'NAMA BANK',
    'NCB',
    'NHB',
    'OCB BANK',
    'OCEANBANK',
    'PGBANK',
    'PVCOMBANK',
    'SACOMBANK',
    'SAIGONBANK',
    'SCB',
    'SCBVL',
    'SEABANK',
    'SHB BANK',
    'SHINHAN BANK VN',
    'TECHCOMBANK',
    'TIMO BANK',
    'TPBANK',
    'UBANK',
    'UOB',
    'VDB',
    'VIB BANK',
    'VIDPULICK BANK',
    'VIET CAPITAL BANK',
    'VIETA BANK',
    'VIETBANK',
    'VIETCOMBANK',
    'VIETINBANK',
    'VIETNAM BANK FOR SOCIAL POLICIES',
    'VIKKI BANK',
    'VPBANK',
    'VRB ( VIET NGA)',
    'WOORI BANK',
  ],
  LIST_REQUEST_BANK: [
    "Thêm số tài khoản",
    "Đổi số tài khoản",
  ],
};